
import { useEffect, useState } from "react";
import HeaderPorto from "../../components/header/headerPorto";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import FooterComponent from "../../components/footer/footer";
import ToTop from "../../components/totop/toptop";

export default function PortfolioPage(props) {
  const [theme, setTheme] = useState(() => {
    // Ambil nilai dari localStorage
    const savedTheme = localStorage.getItem('Dark_Mode');
    // Jika ada nilai di localStorage, gunakan itu. Jika tidak, gunakan "light"
    return savedTheme ? savedTheme : "light";
  });

  useEffect(() => {
    window.scrollTo(0,0);
  }, [])

  const handleTheme = (newValue) => {
    setTheme(newValue);
  };

  useEffect(() => {
    const data = window.localStorage.getItem("Dark_Mode");
    if (data !== null) setTheme(JSON.parse(data));
  }, []);

  useEffect(() => {
    window.localStorage.getItem("Dark_Mode", JSON.stringify(theme));
  }, [theme]);

  return (
    <>
       <Helmet>
        <title>Alcott - Projects</title>
      </Helmet>
      <div className="" id={theme}>
        <HeaderPorto onThemeChange={(value) => handleTheme(value)} theme={theme} />

        <div className="pt-20">
          <div className="absolute p-3 xl:left-[190px] pt-5 cursor-pointer z-50">
            <Link to="/">
              <div className="labelTogg">
                {theme === "light" ? (
                  <img
                    src="https://res.cloudinary.com/alcottimg/image/upload/v1660549833/Website%20Alcott%20Smg/Icon/Kiri-B_hjkwig.png"
                    className=""
                  />
                ) : (
                  <img
                    src="https://res.cloudinary.com/alcottimg/image/upload/v1660549833/Website%20Alcott%20Smg/Icon/Kiri-W_t4ylqm.png"
                    className=""
                  />
                )}
              </div>
            </Link>
          </div>

          <div className="relative w-[90%] m-auto">
            <div className="relative flex flex-wrap items-center">
              <div className="flex flex-col text-center w-full">
                <h1 className="servicePortofoliotitle labelTogg">Projects</h1>
              </div>
            </div>
            <div className="text-center w-full">
              <p className="text-center labelTogg text-[1em] 2xl:text-[1.25em] py-[.8rem]">
                High-quality digital products, wrapped in a modern design, and based on a strong data structure.
              </p>
            </div>
          </div>

          <div className="pt-2 mb-30 w-auto lg:w-[90%] m-auto">
            <div className="py-0">
              <div className="flex flex-wrap justify-center mb-14">
                <div className="relative p-3 my-5 flex flex-col lg:flex-row justify-center items-center w-full">
                  <div className=" block lg:w-[50%] lg:pt-10 lg:px-20">
                    <img
                      src="https://res.cloudinary.com/alcottimg/image/upload/v1671520795/Website%20Alcott%20Smg/Portfolio/Work_Tasks_Payroll_Planner_App_x6c8kw.png"
                      alt="Project"
                      className="block lg:w-[]"
                    />
                  </div>

                  <div className=" relative block text-justify lg:w-[50%] lg:pt-10 lg:px-20">
                    <h1 className="labelTogg pb-6 pt-6 lg:pb-3 lg:pt-3 text-center text-[1.2em] xl:text-[1.5rem] 2xl:text-[1.875em] font-bold">
                      Work Tasks & Payroll Planner
                    </h1>
                    <p className="labelTogg text-center text-[1em] 2xl:text-[1.25em]">
                      This is an internal application that can connect between the company and its employees. Through the dashboard, the company can monitor all the work done by its employees through their gadgets. Companies can also monitor the costs that must be given to their employees.
                    </p>
                  </div>
                </div>

                <div className="relative p-3 my-5 flex flex-col lg:flex-row justify-center items-center">
                  <div className="order-0 lg:order-1 block lg:w-[50%] lg:pt-10 lg:px-20">
                    <img
                      src="https://res.cloudinary.com/alcottimg/image/upload/v1671520795/Website%20Alcott%20Smg/Portfolio/Works_Space_Booking_Systems_App_gbkg4i.png"
                      alt="Project"
                      className="block lg:w-[]"
                    />
                  </div>

                  <div className="relative block text-justify lg:w-[50%] lg:pt-10 lg:px-20">
                    <h1 className="labelTogg pb-6 pt-6 lg:pb-3 lg:pt-3 text-center text-[1.2em] xl:text-[1.5rem] 2xl:text-[1.875em] font-bold">
                      Works Space Booking Systems
                    </h1>
                    <p className="labelTogg text-center text-[1em] 2xl:text-[1.25em]">
                      It's an online app-based booking working space for individuals and businesses. This app can also calculate of how many we can saving carbons from our work. We developed the apps for iOS and Android, and also developed the dashboard for managing booking process.
                    </p>
                  </div>
                </div>

                <div className="relative p-3 my-5 flex flex-col lg:flex-row justify-center items-center">
                  <div className="order-0 block lg:w-[50%] lg:pt-10 lg:px-20">
                    <img
                      src="https://res.cloudinary.com/alcottimg/image/upload/v1671520796/Website%20Alcott%20Smg/Portfolio/Drainage_Monitoring_IoT_App_ufpjr9.png"
                      alt="Project"
                      className="block lg:w-[]"
                    />
                  </div>

                  <div className="relative block text-justify lg:w-[50%] lg:pt-10 lg:px-20">
                    <h1 className="labelTogg pb-6 pt-6 lg:pb-3 lg:pt-3 text-center text-[1.2em] xl:text-[1.5rem] 2xl:text-[1.875em] font-bold">
                      Drainage Monitoring IoT
                    </h1>
                    <p className="labelTogg text-center text-[1em] 2xl:text-[1.25em]">
                      Drainage Monitoring IoT App is a dashboard for monitoring smart sensors installed in gully drainage and soakaway. In this dashboard we can see gully location base on map, so it will make the technician easier to check the location for fixing issue or maintaining gully.
                    </p>
                  </div>
                </div>

                <div className="relative p-3 my-5 flex flex-col lg:flex-row justify-center items-center">
                  <div className="order-0 lg:order-1 block lg:w-[50%] lg:pt-10 lg:px-20">
                    <img
                      src="https://res.cloudinary.com/alcottimg/image/upload/v1671695325/Website%20Alcott%20Smg/Portfolio/Environmental_Empowerment_Monitoring_rcb7dc.png"
                      alt="Project"
                      className="block lg:w-[]"
                    />
                  </div>

                  <div className="relative block text-justify lg:w-[50%] lg:pt-10 lg:px-20">
                    <h1 className="labelTogg pb-6 pt-6 lg:pb-3 lg:pt-3 text-center text-[1.2em] xl:text-[1.5rem] 2xl:text-[1.875em] font-bold">
                      Environmental Empowerment Monitoring
                    </h1>
                    <p className="labelTogg text-center text-[1em] 2xl:text-[1.25em]">
                      Environmental Empowerment Monitoring helps organisations across the capital ensure that they are ready for anything. Environmental Empowerment Monitoring professionals with cutting edge tools and the most up-to-date information available in real time. Service to help ensure your business can survive, cope and recover from disaster.
                    </p>
                  </div>
                </div>

                <div className="relative p-3 my-5 flex flex-col lg:flex-row justify-center items-center">
                  <div className="order-0 block lg:w-[50%] lg:pt-10 lg:px-20">
                    <img
                      src="https://res.cloudinary.com/alcottimg/image/upload/v1671695325/Website%20Alcott%20Smg/Portfolio/Movie_License_Purchasing_App_wfzd8l.png"
                      alt="Project"
                      className="block lg:w-[]"
                    />
                  </div>

                  <div className="relative block text-justify lg:w-[50%] lg:pt-10 lg:px-20">
                    <h1 className="labelTogg pb-6 pt-6 lg:pb-3 lg:pt-3 text-center text-[1.2em] xl:text-[1.5rem] 2xl:text-[1.875em] font-bold">
                      Movie License Purchasing
                    </h1>
                    <p className="labelTogg text-center text-[1em] 2xl:text-[1.25em]">
                      This application makes it easy for users to purchase copyright licenses for allows organizations, corporations, associations, and other groups or institutions to show legally obtained motion pictures, television programs, and other audiovisual content that are originally.
                    </p>
                  </div>
                </div>

                <div className="relative p-3 my-5 flex flex-col lg:flex-row justify-center items-center">
                  <div className="order-0 lg:order-1 block lg:w-[50%] lg:pt-10 lg:px-20">
                    <img
                      src="https://res.cloudinary.com/alcottimg/image/upload/v1671695442/Website%20Alcott%20Smg/Portfolio/Marketing_Journey_Planner_App_tjqhop.png"
                      alt="Project"
                      className="block lg:w-[]"
                    />
                  </div>

                  <div className="relative block text-justify lg:w-[50%] lg:pt-10 lg:px-20">
                    <h1 className="labelTogg pb-6 pt-6 lg:pb-3 lg:pt-3 text-center text-[1.2em] xl:text-[1.5rem] 2xl:text-[1.875em] font-bold">
                      Marketing Journey Planner
                    </h1>
                    <p className="labelTogg text-center text-[1em] 2xl:text-[1.25em]">
                      Marketing Journey Planner App is mobile application for business. Geolocate client base by connecting to exiting system or utilise its own simple, but powerful embedded CRM. Powerful features including : custom radius search, expenses reporting, geolocation based marketing etc.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FooterComponent />
      </div>

      <ToTop />
    </>
  );
}
